import React, { Component } from 'react';
import { graphql } from 'react-relay';
import DistributionBarChart from '../../../../components/DistributionBarChart';
import CsatLineChart from '../../../../components/CsatLineChart';
import withWidgetHeaderAndFooter from '../../../../components/withWidgetHeaderAndFooter';
import withWidgetData from '../../../../components/withWidgetData';
import withReportFilterProps from '../../../../components/withReportFilterProps';
import notifyPhantomWhenMounted from '../../../../components/notifyPhantomWhenMounted';
import GaugeCsat from '../../../GaugeCsat';

@withReportFilterProps
@withWidgetData(
  graphql`
    query SmileysCsatWidgetQuery(
      $widgetId: ID!
      $from: String!
      $to: String!
      $deviceIds: [ID]!
      $filterComments: Boolean!
      $demoData: Boolean!
      $questionFilters: [QuestionFilterInput]
      $aggregateQuestions: [ID]
    ) {
      widget(id: $widgetId) {
        id
        name
        config {
          subtitle
          hideHeader
          staticYAxisScale
          useNumbers
          question {
            type
            text {
              language
              text
            }
            answersReport(
              from: $from
              to: $to
              deviceIds: $deviceIds
              filterComments: $filterComments
              demoData: $demoData
              questionFilters: $questionFilters
              aggregateQuestions: $aggregateQuestions
            ) {
              count
              ...GaugeCsat_answersReport
              ...DistributionBarChart_answersReport
              ...CsatLineChart_answersReport
            }
            ...DistributionBarChart_question
          }
        }
      }
    }
  `,
)
@notifyPhantomWhenMounted()
@withWidgetHeaderAndFooter()
class SmileysCsatWidget extends Component {

  render() {
    const styles = {
      left: {
        display: 'inline-block',
        width: this.props.width / 3,
      },
      right: {
        display: 'inline-block',
        width: (this.props.width * 2 / 3) - 1, // -1 to make sure both always fit
      },
    };
    const widget = this.props.widget;
    const question = widget.config.question;

    return (
      <div>
        <div style={styles.left}>
          <GaugeCsat
            answersReport={question.answersReport}
            height={this.props.bodyHeight / 2}
            width={this.props.width / 3}
            uniqueId={widget.id + '-gauge'}
            widgetConfig={widget.config || {}}

          />
        </div>
        <div style={styles.right}>
          <DistributionBarChart
            question={question}
            answersReport={question.answersReport}
            height={this.props.bodyHeight / 2}
            width={this.props.width * 2 / 3}
            colorBars={true}
            uniqueId={widget.id + '-distribution'}
            widgetConfig={widget.config || {}}

          />
        </div>
        <div>
          <CsatLineChart
            question={question}
            answersReport={question.answersReport}
            staticYAxisScale={widget.config.staticYAxisScale}
            height={this.props.bodyHeight / 2}
            width={this.props.width}
            uniqueId={widget.id + '-line'}
            widgetConfig={widget.config || {}}

          />
        </div>
      </div>
    );
  }
}

export default SmileysCsatWidget;



// WEBPACK FOOTER //
// ./src/components/widgetTypes/components/SmileysCsatWidget/SmileysCsatWidget.js